import styled from 'styled-components'
import { theme } from '../../../styles/theme'

interface IContainer {
  image?: string;
}

export const Container = styled.div<IContainer>`
  height: 100vh;
  position: relative; 
  overflow-x: hidden;

  display: block;
  flex-direction: column;
  align-items: center;

  background: ${theme.colors.white};
`
